<template>
    <div>
        <span v-if="isPermanent">{{ $t('notification.formDeletedPermanent', {
            user: $_.get(activity, 'actorUser.name'),
            formName: $_.get(activity, 'payload.formName'),
            formId: $_.get(activity, 'payload.formId')
        }) }}</span>
        <span v-else>{{ $t('notification.formDeleted', {
            user: $_.get(activity, 'actorUser.name'),
            formName: $_.get(activity, 'payload.formName'),
            formId: $_.get(activity, 'payload.formId')
        }) }}</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "FormDeleted",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        isPermanent() {
            return this.$_.get(this.activity, 'payload.isPermanent', false);
        }
    }
});
</script>

<style scoped lang="scss"></style>

